var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.treeData,"show-checkbox":"","default-expanded-keys":_vm.defCheckKeys,"node-key":"id","highlight-current":"","props":_vm.defaultProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }